import React from "react";

export default function Web_React() {
  return (
    <div>
      <h1>What is React</h1>
      <p>
        Route: <code>/web/react</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
